import * as React from 'react';
import Wrapper from './Wrapper';

const ArrowUp = Wrapper(props => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={props.size || 16}
    width={props.size || 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke={props.stroke || '#535B64'}
    {...props}
  >
    <path
      d="M3 17l8.576-8.82a.59.59 0 01.848 0L21 17"
      stroke="current"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default ArrowUp;
